<!-- selected tt view -->
<ion-grid *ngIf="currentTtg">
  <ion-row>
    <ion-col>
      <div class="c3-flex-column">
        <ng-container
          [ngTemplateOutlet]="ttgItem"
          [ngTemplateOutletContext]="{ $implicit: currentTtg }"
        >
        </ng-container>
      </div>
    </ion-col>

    <ion-col size="auto">
      <ion-buttons *ngIf="!disabled">
        <ion-button color="secondary" (click)="onTtSelected(null)">
          <ion-icon class="ion-hide-md-up" [src]="'find-replace' | getIcon"></ion-icon>
          <span class="ion-hide-md-down">Cambia Schema</span>
        </ion-button>
      </ion-buttons>
    </ion-col>
  </ion-row>
</ion-grid>

<!-- search field -->
<ng-container *ngIf="!currentTtg">
  <ion-item>
    <!-- <ion-label position="stacked">Template</ion-label> -->
    <ion-icon slot="start" [src]="'magnify' | getIcon"></ion-icon>
    <ion-input
      type="text"
      [c3Autocomplete]="autocomplete"
      required
      placeholder="Inserisci il nome dello schema terapeutico o il principio attivo del farmaco (minimo 3 caratteri)"
      [ngModel]="ttgSearchValue"
      (ngModelChange)="onDoSearch($event)"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="disabled"
    >
    </ion-input>

    <ion-spinner slot="end" color="secondary" *ngIf="searchPending"></ion-spinner>
  </ion-item>

  <c3-autocomplete #autocomplete="c3Autocomplete">
    <ng-template c3AutocompleteContent>
      <ion-list>
        <ion-list-header *ngIf="searchResults?.length === 0">
          <ion-label>Nessun risultato</ion-label>
        </ion-list-header>

        <c3-option *ngFor="let ttg of searchResults" [value]="ttg">
          <ion-item button>
            <ng-container
              [ngTemplateOutlet]="ttgItem"
              [ngTemplateOutletContext]="{ $implicit: ttg }"
            >
            </ng-container>
          </ion-item>
        </c3-option>
      </ion-list>
    </ng-template>
  </c3-autocomplete>
</ng-container>

<ng-template #ttgItem let-ttg>
  <div class="c3-flex-column" class="ion-margin-top ion-margin-bottom">
    <div class="c3-flex ion-margin-bottom ion-align-items-center">
      <div class="app-margin-right">
        <strong>{{ ttg.name[localeId] }}</strong>
      </div>
      <ion-text color="tertiary">
        <small *ngIf="ttg.therapies.length === 1"> {{ ttg.therapies.length }} farmaco</small>
        <small *ngIf="ttg.therapies.length > 1"> {{ ttg.therapies.length }} farmaci</small>
      </ion-text>
    </div>

    <div *ngFor="let tt of ttg.therapies" class="ion-margin-start">
      <small>
        <strong>{{ tt.drug.active_ingredient }}: </strong>
      </small>

      <ion-note>
        <small>
          <ng-container *ngIf="tt.extra && tt.extra['cycle_repeat'] && tt.extra['cycle_duration']">
            {{ tt.extra["cycle_repeat"] }} cicli di {{ tt.extra["cycle_duration"] }} giorni |
          </ng-container>
          Durata {{ tt.duration || "n.d." }} giorni | Frequenza assunzione:
          {{ $any(tt) | therapyFrequencyLabel }}
        </small>
      </ion-note>
    </div>
  </div>
</ng-template>
